var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSubAccount(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.9993 17.5026C14.9993 15.7345 14.297 14.0388 13.0467 12.7886C11.7965 11.5383 10.1008 10.8359 8.33268 10.8359C6.56457 10.8359 4.86888 11.5383 3.61864 12.7886C2.36839 14.0388 1.66602 15.7345 1.66602 17.5026",
    stroke: "#777777",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.33268 10.8333C10.6339 10.8333 12.4993 8.96785 12.4993 6.66667C12.4993 4.36548 10.6339 2.5 8.33268 2.5C6.0315 2.5 4.16602 4.36548 4.16602 6.66667C4.16602 8.96785 6.0315 10.8333 8.33268 10.8333Z",
    stroke: "#777777",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3333 16.6693C18.3333 13.8609 16.6667 11.2526 15 10.0026C15.5478 9.59158 15.9859 9.05184 16.2755 8.43116C16.565 7.81048 16.6971 7.12799 16.66 6.4441C16.6229 5.76021 16.4178 5.09601 16.0629 4.51027C15.7079 3.92453 15.2141 3.43532 14.625 3.08594",
    stroke: "#777777",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubAccount);
export default __webpack_public_path__ + "static/media/SubAccount.8d83a4d9e7e0f8968847fe6ade7a9ccc.svg";
export { ForwardRef as ReactComponent };